import ArchivedSafetyTeamTable from './ArchivedSafetyTeamTable'
export { ArchivedSafetyTeamTable }
export default ArchivedSafetyTeamTable
